const highlightPageData = {
    header: {
        title: "2023 ESG Highlights",
        subtitle: "From its inception, SAB has played a part in driving economic growth and societal progress in the Kingdom. Today, we have an equally pivotal role to play in making a real and lasting difference to our environment, communities, and people. Below are some key highlights of the impact of SAB’s efforts on ESG matters:",
        image: {
            name: "highlight.jpg",
            alt: "Highlight Background",
        }
    },
    sectionOne: {
        title: {
            text: "Economic",
            icon: "economic.svg",
        },
        subsectionOne: {
            title: "Sustainable Finance",
            subtitle: "As of December 2023, SAB has achieved growth in their Sustainable Finance portfolio. These include the Bank's lending to its corporate customers, Green Deposits and Investments in Green Bonds",
            label: {
                titleOne: "SAR 12,634 Million",
                subtitleOne: "Balances of",
                titleTwo: "",
                subtitleTwo: "",
            }
        },
        subsectionTwo: {
            titleOne: "NEOM Green Hydrogen",
            subtitleOne: "SAB supports the financing of the world’s largest carbon-free green hydrogen and green ammonia plant with a green loan facility.",
        },
        subsectionThree: {
            title: "Best Bank for ESG in the Kingdom Award 2023",
            subtitle: "SAB was awarded the Best ESG Bank for ESG and Best Bank for ESG Investing by Euromoney for 2023",
        }
    },
    sectionTwo: {
        title: {
            text: "Environment",
            icon: "environment.svg",
        },
        subsectionOne: {
            title: "Saudi Green Initiative",
            subtitle: <p>SAB partnered with National Centre for Vegetation Cover on the <b>10 billion trees initiative.</b> We aim to plant <b>1 million trees</b> by 2030. Continued progress on planting a million trees</p>,
            label: {
                title: "60,000 trees",
                subtitle: "By 2023, we had planted"
            }
        },
        subsectionTwo: {
            title: "Transition to Net Zero Programme*",
            subtitle: "SAB’s internal greening initiatives resulted in:",
            gridOne: [
                {
                    title: "2.6 million",
                    subtitle: "plastic water bottles saved",
                },
                {
                    title: "13,200kg",
                    subtitle: "recycled paper",
                }
            ],
            gridTwo: [
                {
                    title: "1.7 million kW",
                    subtitle: "energy saved"
                },
                {
                    title: "221,884 ℓ",
                    subtitle: "of water saved Bank-wide"
                }
            ]
        },
        subsectionThree: {
            title: "New SAB Headquarters*",
            subtitle: "LEED Gold and Smart Score Platinum status",
            gridOne: [
                {
                    title: "28.47% ",
                    subtitle: "reduction in operational energy consumption",
                },
                {
                    title: "59.25%",
                    subtitle: "reduction in water consumption for landscaping",
                }
            ],
            gridTwo: [
                {
                    title: "75%",
                    subtitle: "of construction waste was recycled"
                },
                {
                    title: "54.3%",
                    subtitle: "reduction in indoor water consumption "
                }
            ]
        },
        note: "* The numbers mentioned above are calculated on an annual basis"
    },
    sectionThree: {
        title: {
            text: "Social",
            icon: "social.svg",
        },
        subsectionOne: {
            title: "Riyali",
            subtitle: "In school year 2022/23, over 730,000 students were able to benefit from Riyali",
            label: {
                title: "730,000 ",
                subtitleOne: "Over",
                subtitleTwo: "students across the Kingdom benefitted"
            }
        },
        subsectionTwo: {
            title: "Women's representation in the organisation",
            subtitle: "The Bank has made progress towards gender diversity with women representation",
            label: {
                title: "50%",
                subtitleOne: "standing at",
                subtitleTwo: "in the Executive Management team"
            }
        },
        subsectionThree: {
            title: "Taqadam",
            subtitle: "As of 2023, six cohorts of the TAQADAM Program have been completed with significant success and achievements for all stakeholders",
            gridOne: [
                {
                    title: "150 startups",
                },
                {
                    title: "600 individuals",
                    subtitle: ""
                }
            ]
        },
        subsectionFour: {
            title: "Goumbook",
            subtitle: "150 application received (22% Saudi) and 21 semi-finalist (25% Saudi)",
            label: {
                title: "",
                subtitle: ""
            },
        },
        subsectionFive: {
            title: "Khanzah Project",
            subtitle: "aims to enhance women’s financial independence through improved financial literacy, enabling better financial planning and management of daily expenses",
            label: {
                title: "",
                subtitleOne: "",
                subtitleTwo: ""
            }
        },
        subsectionSix: {
            title: "",
            subtitle: "",
            gridOne: [
                {
                    title: "",
                    subtitleOne: "",
                    subtitleTwo: "",
                },
                {
                    title: "",
                    subtitleOne: "",
                    subtitleTwo: "",
                },
                {
                    subtitleOne: "",
                    title: "",
                    subtitleTwo: ""
                }
            ]
        }
    },
    sectionFour: {
        title: {
            text: "Governance",
            icon: "governance.svg",
        },
        subsectionOne: {
            title: "Strengthening our ESG Framework",
            subtitle: <p>We implemented an <b>ESG governance structure,</b> including a new ESG Steering Committee overseeing the delivery of SAB’s ESG strategy. </p>,
        },
        subsectionTwo: {
            title: "Excellence in procurement Programme (PEP) Award",
            subtitle: <p>The <b>Chartered Institute of Purchasing and Supply (CIPS)</b> awarded PEPs to SAB in 2023. </p>,
        },
        subsectionThree: {
            title: "CIB Sustainable Finance Forum",
            subtitle: <p>SAB’s new <b>CIB Sustainable Finance</b> Forum oversees sustainable lending. </p>,
        },
        subsectionFour: {
            title: "United Nations Principles for Responsible Banking (UNPRB) ",
            subtitle: <p>SAB is the first bank in Saudi Arabia to become a signatory to the UNPRB, a part of the United Nations Environment Programme Financial Initiative.</p>,
        },
        subsectionFive: {
            title: "ESG champions",
            subtitle: <p><b>35 ESG champions</b> have been appointed and trained across SAB.</p>
        },
        subsectionSix: {
            title: "Management Committees (MCs)",
            subtitle: <p>SAB reduced its <b>40 MCs to 24 committees</b> focusing on economic, environmental, and social impacts, in line with regulation and best practices. </p>
        },
        subsectionSeven: {
            title: "SAB Sustainable Debt Framework",
            subtitle: <p>This framework is primarily designed for bond and Sukuk issuances, but it is also used to apply appropriate thresholds to the relevant green or social underlying assets. Following a comprehensive review process, including a Second Party Opinion (SPO) by S&P Global and thorough internal scrutiny, the framework is now publicly available on our website</p>
        },
        subsectionEight: {
            title: "SAB Sustainable Data Dictionary",
            subtitle: <p>At the heart of SAB’s approach to sustainable finance lies the Sustainable Finance Data Dictionary. This comprehensive tool delineates the principles governing ESG-focused products and the international standardss to which they adhere to.</p>
        },
        subsectionNine: {
            title: "SAB Climate Risk Framework",
            subtitle: <p>SAB’s Climate Risk Framework addresses diverse risks and outlines perspectives on impact and control enhancements. Considering insights from the Task Force on Climate-related Financial Disclosures (TCFD), SAB identified a range of risks. For the bank, physical risks (e.g., extreme weather events, long-term shifts in climate patterns) and transition risks (e.g., change in
                legislation, change in consumer perception) can materialise in a variety of different ways.</p>
        }
    }
}

export default highlightPageData;